import {  MultipleSelectionDropdown } from "./multiselect/multiselect.component";

// For backward compatability
export { MultipleSelectionDropdown };

export default MultipleSelectionDropdown;